import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {
    BillingDocumentFinalizePreviewRes,
    BillingDocumentFinalizeReq,
    InvoiceCreateReq,
    InvoiceDetailRes,
    InvoicePaidReq,
    InvoiceProjectSourceReq,
    InvoiceProjectSourceRes,
    InvoiceSendReq,
    InvoiceUpdateReq,
} from '../../../../contracts/v0/cp/invoice.contract';

export class ApiV0Invoice {
    segment = '/invoice';

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(req: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<InvoiceDetailRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<InvoiceDetailRes>>(
            `${this.segment}/search`,
            InvoiceDetailRes,
            req,
        );
    }


    importPreview(file: File): Observable<InvoiceDetailRes> {
        const form = new FormData();
        form.append('file', file, file.name);
        return this.rest.post<FormData, InvoiceDetailRes>(`${this.segment}/Import/Preview`, InvoiceDetailRes, form);
    }

    importInvoice(file: File): Observable<InvoiceDetailRes> {
        const form = new FormData();
        form.append('file', file, file.name);
        return this.rest.post<FormData, InvoiceDetailRes>(`${this.segment}/Import`, InvoiceDetailRes, form);
    }

    exportUrl(id: number): string {
        return `${this.segment}/${id}/Export`;
    }

    createDraft(req: InvoiceCreateReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoiceCreateReq, InvoiceDetailRes>(`${this.segment}/Draft`, InvoiceDetailRes, req);
    }

    add(req: InvoiceCreateReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoiceCreateReq, InvoiceDetailRes>(this.segment, InvoiceDetailRes, req);
    }

    update(id: number, req: InvoiceUpdateReq): Observable<InvoiceDetailRes> {
        return this.rest.patch<InvoiceUpdateReq, InvoiceDetailRes>(`${this.segment}/${id}`, InvoiceDetailRes, req);
    }

    createRevision(id: number): Observable<InvoiceDetailRes> {
        return this.rest.post<Record<string, never>, InvoiceDetailRes>(
            `${this.segment}/${id}/Revision`,
            InvoiceDetailRes,
            {},
        );
    }

    finalizePreview(id: number): Observable<BillingDocumentFinalizePreviewRes> {
        return this.rest.post<Record<string, never>, BillingDocumentFinalizePreviewRes>(
            `${this.segment}/${id}/FinalizePreview`,
            BillingDocumentFinalizePreviewRes,
            {},
        );
    }

    finalize(id: number, req: BillingDocumentFinalizeReq): Observable<InvoiceDetailRes> {
        return this.rest.post<BillingDocumentFinalizeReq, InvoiceDetailRes>(
            `${this.segment}/${id}/Finalize`,
            InvoiceDetailRes,
            req,
        );
    }

    markPaid(id: number, req: InvoicePaidReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoicePaidReq, InvoiceDetailRes>(`${this.segment}/${id}/Paid`, InvoiceDetailRes, req);
    }

    cancel(id: number): Observable<InvoiceDetailRes> {
        return this.rest.post<Record<string, never>, InvoiceDetailRes>(
            `${this.segment}/${id}/Cancel`,
            InvoiceDetailRes,
            {},
        );
    }

    send(id: number, req: InvoiceSendReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoiceSendReq, InvoiceDetailRes>(`${this.segment}/${id}/Send`, InvoiceDetailRes, req);
    }

    projectSource(req: InvoiceProjectSourceReq): Observable<InvoiceProjectSourceRes> {
        return this.rest.post<InvoiceProjectSourceReq, InvoiceProjectSourceRes>(
            `${this.segment}/ProjectSource`,
            InvoiceProjectSourceRes,
            req,
        );
    }

    delete(id: number): Observable<void> {
        return this.rest.delete<void>(`${this.segment}/${id}`);
    }
}
